export type ShipmentExceptionType =
	| "immediateActionExceptions"
	| "needsAcknowledgedExceptions";

export const SHIPMENT_EXCEPTION_LABELS: Record<
	ShipmentExceptionType,
	{ readonly banner: string; readonly modalTitle: string }
> = {
	immediateActionExceptions: {
		banner: "Exception(s) Requiring Immediate Action",
		modalTitle: "Exceptions Requiring Immediate Action",
	},
	needsAcknowledgedExceptions: {
		banner: "Exception(s) Requiring Acknowledgement",
		modalTitle: "Exceptions Requiring Acknowledgement",
	},
};
